import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { UserRulesTemplateRepository } from "../../repositories/user-rules-template.repository";
import { UserRulesTemplate } from "../../domain/models/user-rules-template";
@Injectable({ providedIn: 'root' })
export class GetUserRulesTemplateByIdUsecase implements UseCase<string, UserRulesTemplate> {
  constructor(private readonly userRulesTemplateRepository: UserRulesTemplateRepository) {
  }

  execute(params: string): Observable<UserRulesTemplate> {
    return this.userRulesTemplateRepository.getUserRulesTemplateById(params);
  }
}
